<template>
  <section class="invoice-preview-wrapper mt-2">
    <b-row class="invoice-preview">

      <!-- Left Col: Card -->
      <b-col
        cols="12"
        md="4"
        xl="3"
        class="invoice-actions"
      >
        <b-card>

          <!-- Button: Send Invoice -->
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mb-75"
            block
            @click="printInvoice"
          >
            Imprimir {{ idOrden }}
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="info"
            class="mb-75"
            block
            @click="loadDatos()"
          >
            Actualizar
          </b-button>
          <!-- Spacer -->
          <hr class="invoice-spacing">
          <!-- files vinculados  -->
          <h5 class="card-title">
            Constancia de Situación Fiscal
          </h5>
          <b-col md="12">
            <b-list-group>
              <b-list-group-item
                v-for="(file, index) in storedFiles"
                :key="index"
                class="d-print-inline-block border"
                style="cursor: pointer;"
                @click="downloadFile(file)"
              >
                <span class="mr-1">
                  <feather-icon
                    icon="FileTextIcon"
                    size="16"
                  />
                </span>
                <span>{{ smarText(file.rutaDoc+file.extBase,12, true) }}</span>
              </b-list-group-item>
            </b-list-group>
          </b-col>
          <hr class="invoice-spacing">

          <!-- Note -->
          <b-card-body class="invoice-padding pt-0 text-center">
            <span class="font-weight-bold">Nota: </span>
            <span>La información aqui mostrada son los datos de facturación que acompañaran al comprobante de pago para realizar una factura.</span>
          </b-card-body>
          <!-- like footer -->
          <template #footer>
            <em>Al terminar puede cerrar esta ventana</em>
          </template>

        </b-card>
      </b-col>

      <!-- Col: Right (Invoice Container) -->
      <b-col
        cols="12"
        xl="9"
        md="8"
      >
        <b-card
          no-body
          class="invoice-preview-card"
        >
          <!-- Header -->
          <b-card-body class="invoice-padding pb-0">
            <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
              <!-- Header: Left Content -->
              <div>
                <div class="logo-wrapper m-0">
                  <logo />
                </div>
              </div>
            </div>
          </b-card-body>

          <!-- lo que se imprime -->
          <b-overlay
            :show="showLoader"
            rounded="sm"
          >
            <div class="mx-4">
              <b-row>
                <b-col class="col-6">
                  RAZON SOCIAL: <b class="ml-2">{{ infofact.razon }}</b>
                </b-col>
                <b-col class="col-6 text-right">
                  #: {{ idOrden }}
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col class="col-md-6 col-lg-6">
                  RFC: <b>{{ infofact.rfc }}</b>
                </b-col>
                <b-col class="col-md-6 col-lg-6">
                  CURP: <b>{{ infoPersona.curp }}</b>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col class="col-md-6 col-lg-6">
                  REGIMEN FISCAL DEL RECEPTOR: <b>{{ infofact.codigo_regimen }} | {{ infofact.desc_regimen }}</b>
                </b-col>
                <b-col class="col-md-6 col-lg-6">
                  CÓDIGO POSTAL: <b>{{ infofact.cp }}</b>
                </b-col>
              </b-row>
              <b-row class="mt-1 mb-4">
                <b-col class="col-12">
                  DOMICILIO FISCAL: <b>{{ infofact.calle }}, {{ infofact.numero }} - {{ infofact.int }}, {{ infofact.colonia }}.
                    <span> referencias: {{ infofact.ref1 }} / {{ infofact.ref2 }}</span></b>
                </b-col>
              </b-row>
              <b-row class="mt-1">
                <b-col class="col-md-6 col-lg-6">
                  MUNICIPIO: <b>{{ infofact.municipio }}</b>
                </b-col>
                <b-col class="col-md-6 col-lg-6">
                  ESTADO: <b>{{ infofact.estado }}</b>
                </b-col>
              </b-row>
              <b-row class="mt-1">
                <b-col class="col-md-6 col-lg-6">
                  TELEFONOS DE CONTACTO: <b>{{ infoPersona.telefono1 }}</b>
                </b-col>
                <b-col class="col-md-6 col-lg-6">
                  CORREOS ELECTRÓNICOS (PARA RECEPCIÓN DE CFDI): <b>{{ infofact.correo1 }} / {{ infofact.correo2 }}</b>
                </b-col>
              </b-row>
              <b-row class="mt-1">
                <b-col class="col-md-6 col-lg-6">
                  METODO DE PAGO: <b>{{ infoSolicitud.metodoPago }}</b>
                </b-col>
                <b-col class="col-md-6 col-lg-6">
                  FORMA DE PAGO: <b>{{ infoSolicitud.forma_pago }}</b>
                </b-col>
              </b-row>
              <b-row class="mt-1">
                <b-col class="col-12">
                  USO DE CFDI: <b>{{ infofact.usoCFDI }}</b>
                </b-col>
              </b-row>
              <b-row class="mt-1">
                <b-col class="col-12">
                  CONCEPTO DE APORTACIÓN: <b>Especialidad</b>
                </b-col>
              </b-row>
              <b-row class="mt-1">
                <b-col class="col-12">
                  NOMBRE: <b>{{ infoPersona.nombreCompleto }}</b>
                </b-col>
              </b-row>
            </div>
            <!-- Spacer -->
            <hr class="invoice-spacing">
            <!-- Note -->
            <b-card-body class="invoice-padding mt-4 pt-0 text-center">
              <span>FAVOR DE ANEXAR COMPROBANTE DE PAGO (POR CADA APORTACIÓN QUE SE REALICE), CONSTANCIA DE SITUACIÓN FISCAL (UNA VEZ POR EJERCICIO FISCAL)</span>
            </b-card-body>
            <hr class="invoice-spacing">
            <b-card-body class="invoice-padding pt-0 text-center">
              <span class="text-success">EN CASO DE SOLICITAR LA EMISION DE CFDI ANTICIPADO CON FORMA DE PAGO AJENA A 099- POR DEFINIR Y METODO DE PAGO AJENO A PPD- PAGO EN PARCIALLIDADES O DIFERIDO. LA APORTACIÓN DEBERA SER CUBIERTA DENTRO DEL MISMO MES EN EL QUE SE EMITA EL CFDI. EN CASO DE QUE SE INCUMPLA, SE PROCEDERA A REALIZAR LA REVOCACION DEL DOCUMENTO Y EMITIR UNO NUEVO.</span><p />
              <span class="text-danger">NO SE PODRÁN HACER REVOCACIONES DE CFDI, PARA ACTUALIZACIÓN DE FECHA.</span>
            </b-card-body>
            <hr class="invoice-spacing">
            <b-card-body class="invoice-padding pt-0 text-center">
              <span>CUALQUIER CORRECCION DE CFDI PREVIAMENTE TIMBRADO, DEBERA SOLICITARSE POR CORREO, DENTRO DEL MES EN EL QUE SE EFECTUO LA APORTACIÓN; Y EN ATENCIÓN A LO ESTABLECIDO EN EL REFORMADO PENÚLTIMO PÁRRAFO DEL ARTICULO 29-A DEL CFF, LA SOLICITUD DE CANCELACIÓN DE CFDI, DEBERÁ ESTAR JUSTIFICADA Y SOPORTADA DOCUMENTALMENTE.</span><p />
              <span class="text-info">EN CASO DE QUE CUALQUIERA DE LA INFORMACIÓN QUE SE SOLICITA, SUFRA ALGUN CAMBIO, AGRADECEMOS NOS LO HAGA SABER (ANTES DE EMITIR EL CFDI CON LA NUEVA INFORMACIÓN) PARA LA ACTUALIZACION DE DATOS.</span>
            </b-card-body>
            <b-card-body class="invoice-padding pt-0 text-center">
              <b-row class="m-0">
                <b-col>
                  <b-row class="text-black-50">
                    <b-col
                      md="12"
                      class="text-center m-2"
                    >
                      <h6>
                        Campus Virtual
                      </h6>
                      <h6>
                        Instituto para el Desarrollo Técnico de las Haciendas Públicas
                      </h6>
                    </b-col>
                  </b-row>
                  <b-row class="mb-0 text-center">
                    <b-col>
                      <p>
                        <span class="d-block d-md-inline-block mt-25">
                          Derechos Reservados © INDETEC  {{ new Date().getFullYear() }}
                        </span>
                      </p>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-card-body>
          </b-overlay>
        </b-card>
      </b-col>

    </b-row>
  </section>
</template>

<script>
import { ref, onMounted } from '@vue/composition-api'
// import router from '@/router'
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BListGroup,
  BListGroupItem,
  // BBadge,
  //   BTableLite,
  //   BCardText,
  BButton, VBToggle,
  //   BTr,
  //   BTh,
  BOverlay,
} from 'bootstrap-vue'
import { useRouter, isEmptyObject } from '@core/utils/utils'
import { smarText } from '@core/utils/filter'
import Logo from '@core/layouts/components/Logo.vue'
import Ripple from 'vue-ripple-directive'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import store from '@/store/index'
import { detailFactura } from './useFormatos'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BListGroup,
    BListGroupItem,
    // BBadge,
    // BTableLite,
    // BCardText,
    BButton,
    // BTr,
    // BTh,
    Logo,
    BOverlay,
    // InvoiceSidebarAddPayment,
    // InvoiceSidebarSendInvoice,
  },
  setup() {
    const { route } = useRouter()
    const showLoader = ref(false)
    const toast = useToast()
    // catch values
    const idFact = (route.value.params.idfact) ? route.value.params.idfact : 0
    const idOrden = (route.value.params.idord) ? route.value.params.idord : 0
    const idTran = (route.value.params.idtran) ? route.value.params.idtran : 0

    const infofact = ref({})
    const infoPersona = ref({})
    const infoSolicitud = ref({})
    const storedFiles = ref([])

    // detalle del curso
    // const CabeceraReport = () => {
    //   showLoader.value = true
    //   cabecerakardex(inplan, incurso).then(response => {
    //     detallesCurso.value = response
    //     showLoader.value = false
    //   }, error => {
    //     showLoader.value = false
    //     toast({
    //       component: ToastificationContent,
    //       props: {
    //         title: 'Atención en petición [Información Curso]',
    //         text: error,
    //         icon: 'AlertCircleIcon',
    //         variant: 'warning',
    //       },
    //     },
    //     { timeout: 9000 })
    //   })
    // }
    //* Download files
    const downloadFile = file => {
      window.open(`${process.env.VUE_APP_DELIVERY_DOWNLOAD}${file.rutaDoc}${file.extBase}`, '_blank')
    }
    // get api participantes.js
    const loadDatos = () => {
      showLoader.value = true
      detailFactura(idFact, idOrden, idTran).then(response => {
        infofact.value = response.datos
        infoPersona.value = response.persona
        infoSolicitud.value = response.solicitud
        storedFiles.value = response.files
        showLoader.value = false
        // CabeceraReport()
      }, error => {
        showLoader.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        },
        { timeout: 9000 })
      })
    }

    const printInvoice = () => {
      window.print()
    }

    onMounted(
      () => {
        loadDatos()
      },
    )

    return {
      // datos
      infofact,
      infoPersona,
      infoSolicitud,
      idOrden,
      storedFiles,
      //   inperiodo,
      // profesor,
      // functions
      printInvoice,
      loadDatos,
      smarText,
      // flags
      showLoader,
      // functions
      isEmptyObject,
      downloadFile,
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
</style>

<style lang="scss">
@media print {
  // Global Styles
  body {
    background-color: transparent !important;
  }
  nav.header-navbar {
    display: none;
  }
  .main-menu {
    display: none;
  }
  .header-navbar-shadow {
    display: none !important;
  }
  .content.app-content {
    margin-left: 0;
    padding-top: 2rem !important;
  }
  footer.footer {
    display: none;
  }
  .card {
    background-color: transparent;
    box-shadow: none;
  }
  .customizer-toggle {
    display: none !important;
  }
  // Invoice Specific Styles
  .invoice-preview-wrapper {
    .row.invoice-preview {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
              > .col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    // Action Right Col
    .invoice-actions {
      display: none;
    }
  }
}
</style>
<style scoped>
  b {
    margin-left: 0.5rem !important;
    font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif
  }
  .headWhite {
      background-color: white !important;
    }
</style>
